import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class TarifsScroll {
	constructor() {
		let cache = {};

		let initFunc = () => {
			initCache();
			if (!cache.section || !cache.imageWrapper) return;
			initScrollTrigger();
		};

		let initCache = () => {
			cache.section = document.querySelector('.tarifs-hero');
			cache.content = document.querySelector('.tarifs-hero__content');
			cache.imageWrapper = document.querySelector('.tarifs-hero__image-wrapper');
			cache.title = document.querySelector('.tarifs-hero__title');
			cache.introduction = document.querySelector('.tarifs-hero__introduction');
			cache.logo = document.querySelector('.tarifs-hero__logo');
			cache.cardWrapper = document.querySelector('.tarifs-hero__card-wrapper');
			cache.card = document.querySelector('.tarifs-hero__card');
		};

		let initScrollTrigger = () => {
			let windowW = window.innerWidth;
			let windowH = window.innerHeight;

			// Calculate card total height to determine scroll distance
			let cardExcess = 0;
			if (cache.card) {
				let cardStyle = getComputedStyle(cache.card);
				let cardMarginTop = parseFloat(cardStyle.marginTop);
				let cardMarginBottom = parseFloat(cardStyle.marginBottom);
				let cardTotalHeight = cardMarginTop + cache.card.offsetHeight + cardMarginBottom;
				cardExcess = Math.max(0, cardTotalHeight - windowH);
			}

			// Phase 1: windowH of scroll for image growth
			// Phase 2: card travels windowH + cardExcess (from below viewport to fully visible)
			let phase2Scroll = windowH + cardExcess;
			let phase2Duration = phase2Scroll / windowH;
			let totalScroll = windowH + phase2Scroll;

			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: cache.section,
					start: 'top top',
					end: '+=' + totalScroll,
					pin: true,
					scrub: true,
				}
			});

			// Phase 1 (0 to 1): grow image width/height to viewport + change ratio
			tl.to(cache.imageWrapper, {
				width: windowW,
				height: windowH,
				duration: 1,
				ease: 'none',
			}, 0);

			if (cache.title) {
				tl.to(cache.title, {
					opacity: 0,
					duration: 0.3,
					ease: 'none',
				}, 0);
			}

			if (cache.introduction) {
				tl.to(cache.introduction, {
					opacity: 0,
					duration: 0.3,
					ease: 'none',
				}, 0);
			}

			if (cache.logo) {
				tl.to(cache.logo, {
					opacity: 0,
					duration: 0.3,
					ease: 'none',
				}, 0);
			}

			// Phase 2: card fades in and slides up over the image (parallax)
			if (cache.cardWrapper) {
				tl.to(cache.cardWrapper, {
					opacity: 1,
					duration: 0.3,
					ease: 'none',
				}, 1);

				tl.fromTo(cache.cardWrapper, {
					y: windowH,
				}, {
					y: -cardExcess,
					duration: phase2Duration,
					ease: 'none',
				}, 1);
			}
		};

		initFunc();
	}
}

export { TarifsScroll };
